export const sortOptionItems = {
  lastNameKana: 'ふりがな（姓）',
  firstNameKana: 'ふりがな（名）',
  lastName: '姓',
  firstName: '名',
  createdDate: '作成日',
  updatedDate: '更新日',
}
export type sortOptionsType = keyof typeof sortOptionItems
